import config from 'constants/config'
import { pluralizeToString } from 'lib/string/pluralize'

export function getOnlyNRoomLeftLabel(
  availableRooms: number,
  isShortFormat?: boolean,
  thresholdOverride?: number,
): string | undefined {
  const threshold = thresholdOverride ?? config.ONLY_N_ROOMS_LEFT_THRESHOLD ?? 3

  if (availableRooms > 0 && availableRooms <= threshold) {
    return isShortFormat ?
        `${pluralizeToString('room', availableRooms)} left` :
        `Only ${pluralizeToString('room', availableRooms)} left`
  }
}
